<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" attach allow-overflow :close-on-content-click="false" offset-y max-height="500" z-index="15")
    template(#activator="{ on }")
      v-sheet.text-sm.round-lg.clickable.border-menu(flat outlined @click="fetchAppointments")
        v-row.py-1(no-gutters align="center" style="min-height: 38px;")
          v-col.shrink
            .d-flex.align-center
              v-icon.mx-3(size="16" color="neutral400") $yzi-search-sm
              .text-sm.neutral500--text Search
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined placeholder="Search" dense hide-details autofocus)
        v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      .d-flex.align-center.justify-space-between.px-4.py-3
        .font-semibold.mr-6 Existing appointment
        y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isFetching") 
      div(v-for="appointment in appointments" @click="onSelectItem(appointment)")
        .pa-4.hover-bg
          .text-sm.font-semibold.mb-1 {{ appointment.lead.name }}
          .d-flex.flex-wrap.gap-2.neutral500--text
            .d-flex.gap-1.mr-2
              v-icon(size="14" color="neutral500") $yzi-calendar
              .text-xs {{ appointment.date }}
            .d-flex.gap-1.mr-2.align-center
              v-icon(size="14" color="neutral500") $yzi-clock
              .text-xs {{ appointment.time }}
            .d-flex.gap-1.align-center
              template(v-if="appointment.provider && Object.keys(appointment.provider).length")
                v-avatar.d-flex.justify-center.align-center.avatar-color(size="14" rounded="circle")
                  template(v-if="appointment.provider.profile_image")
                    v-img.round-lg(width="13" height="13" :src="`https://img.yezza.io/50x50/${appointment.provider.profile_image.path}`")
                  v-icon(v-else size="12" color="neutral500") $yzi-user-01
                .text-xs {{ appointment.provider.name }}
        v-divider
      template(v-if="!appointments.length")
        .px-4.py-3 {{ $t('no_result_match') }}
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'

export default {
  data: () => ({
    isFetching: false,
    show: false,
    itemName: null,
    diagnoses: [],
    toDeleteItem: null,
    isDeleting: false,
    openDeleteConfirmationDialog: false,
    selectedItem: null,
    page: 1,
    pageSize: 10,
    count: 0,
    appointments: [],
    initialized: false
  }),
  watch: {
    page () {
      this.fetchAppointments()
    },
    itemName () {
      this.searchStart()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    searchStart: debounce(function () {
      this.page = 1
      this.fetchAppointments()
    }, 750),
    onSelectItem (item) {
      this.itemName = ''
      this.$emit('selected', item)
    },
    async fetchAppointments () {
      if (this.show && !this.initialized) {
        this.show = false
      }
      try {
        this.isFetching = true

        const params = {
          page: this.page,
          page_size: this.pageSize,
          search: this.itemName,
          statuses: 'new,processed,received,absent'
        }

        const { data } = await this.$axios.get(`/clinics/${this.company.slug}/appointments`, { params })
        this.appointments = data.results.map(result => this.sanitizeData(result))
        this.count = data.count
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
        this.show = true
        this.initialized = true
      }
    },
    sanitizeData (obj) {
      const appointmentDateTime = {
        from: DateTime.fromISO(obj.start),
        until: DateTime.fromISO(obj.until)
      }

      const formatTime = 'h:mm a'

      const allowedProperties = ['id', 'lead', 'provider']
      const newObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)

      newObj.datetime = appointmentDateTime
      newObj.date = appointmentDateTime.from.toFormat('d MMM yyyy')
      newObj.time = `${appointmentDateTime.from.toFormat(formatTime)} - ${appointmentDateTime.until.toFormat(formatTime)}`
      newObj.profileImage = obj.provider?.profile_image?.file || null

      return newObj
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.disabled-item {
  background-color: var(--v-neutral300);
  color: var(--v-neutral500);
}
.avatar-color {
  border: 1px solid var(--v-neutral500);
  color: white;
}
</style>